/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelServiceTransitTime.ts            *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/dispatch/service-transit-time";

export class AutogenModelServiceTransitTime<RowType extends ModelRow> extends Endpoint<RowType, RowServiceTransitTimeFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowServiceTransitTime extends ModelRow<RowServiceTransitTimeFields> {
	constructor(values?: Partial<RowServiceTransitTimeFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowServiceTransitTimeFields {
	add_timestamp: Date;
	add_userid: string;
	calc_type_code: string;
	carrier_scac: string;
	company_id: string;
	destination_loc_id: string;
	destination_partner_id: string;
	destination_reg_name: string;
	destination_reg_type_code: string;
	destination_reg_uid: number;
	effective_timestamp: Date;
	expire_timestamp: Date;
	friday: string;
	include_holidays: string;
	include_saturday: string;
	include_sunday: string;
	mod_timestamp: Date;
	mod_userid: string;
	monday: string;
	order_mode: string;
	origin_loc_id: string;
	origin_partner_id: string;
	origin_reg_name: string;
	origin_reg_type_code: string;
	origin_reg_uid: number;
	payee_id: string;
	priority: number;
	saturday: string;
	service_type_code: string;
	stt_status_code: string;
	stt_type_code: string;
	stt_uid: number;
	sunday: string;
	thru_terminal: string;
	thursday: string;
	transit_days: number;
	transit_hours: number;
	transit_minutes: number;
	tuesday: string;
	wednesday: string;
}

